var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 85L43.7725 79.97C37.1233 74.1017 31.6263 69.0395 27.2813 64.7834C22.9363 60.5272 19.48 56.7064 16.9125 53.3208C14.345 49.9353 12.551 46.8238 11.5306 43.9864C10.5102 41.149 10 38.247 10 35.2807C10 29.2189 12.0737 24.1567 16.2213 20.094C20.3688 16.0313 25.5367 14 31.725 14C35.1483 14 38.4071 14.7094 41.5013 16.1281C44.5954 17.5468 47.2617 19.5459 49.5 22.1253C51.7383 19.5459 54.4046 17.5468 57.4988 16.1281C60.5929 14.7094 63.8517 14 67.275 14C73.4633 14 78.6313 16.0313 82.7788 20.094C86.9263 24.1567 89 29.2189 89 35.2807C89 38.247 88.4898 41.149 87.4694 43.9864C86.449 46.8238 84.655 49.9353 82.0875 53.3208C79.52 56.7064 76.0638 60.5272 71.7188 64.7834C67.3738 69.0395 61.8767 74.1017 55.2275 79.97L49.5 85Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.94a0d92425a6bd2c390254dce13e6635.svg";
export { ForwardRef as ReactComponent };